import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type { MediaItemDetails, MediaItemListResponseDTO } from "../types/mediaLibraryTypes";
import { mediaDetailsTransformer } from "./mediaTransformer";

export async function fetchMediaItemDetails(id: string): Promise<MediaItemDetails[]> {
  const params = new URLSearchParams();
  params.set("id", id);

  const url = occUrl(`/media-library/preview?${params}`);

  const response = await occFetch(url);

  if (!response.ok) {
    throw new Error(`Error status: ${response.status}`);
  }

  const data = (await response.json()) as MediaItemListResponseDTO;
  return mediaDetailsTransformer(data.items);
}
